<template>
    <div class="search-condition-pulldown">
        <label>{{labelName}}<span v-if="required" style="color:#FC1111;">*</span></label>
        <div id="list1" class="dropdown-check-list" :value="value" tabindex="0" v-on:click="disabled == true ? '' : onclickEvent($event)"
             @focusin="onfocusin($event)"
             @focusout="onfocusout">
            <div class="anchor">{{selectedLabel}}</div>
            <ul class="items" :class="Options.length > 5 ? 'isoverFlow':''">
                <li v-for="item in Options" :key="item.id" v-on:click="onClickLi(item,$event)">
                    {{item.text}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BInputPullDown",
        props: {
            labelName: String,
            Options: Array,
            value: String,
            required: Boolean,
            disabled: Boolean,
            placeholder: String,
        },
        data(){
            return {
                selectedLabel:"",
                target: null,
            }
        },
        watch:{
            'value'() {
                for (let i = 0; i < this.Options.length; i++) {
                    if(this.value === this.Options[i].value){
                        this.selectedLabel = this.Options[i].text;
                    }
                }
                if(this.selectedLabel === ""){
                    this.selectedLabel = this.placeholder;
                }
                // console.info(this.selectedLabel);
            }
        },
        mounted() {
            for (let i = 0; i < this.Options.length; i++) {
                if(this.value === this.Options[i].value){
                    this.selectedLabel = this.Options[i].text;
                }
            }
            if(this.selectedLabel === ""){
                this.selectedLabel = this.placeholder;
            }
            // console.info(this.selectedLabel);
        },
        methods :{
            onChangeEvent(event){
                this.$emit("changed",event.target.options[event.target.selectedIndex].value);
                this.$emit("input",event.target.options[event.target.selectedIndex].value);
            },
            onclickEvent(event) {
                var el = event.target.parentElement;
                this.target = el;
                if (el.classList.contains('visible')) {
                    el.classList.remove('visible');
                } else {
                    el.classList.add('visible');
                }
                event.target.parentElement.classList.add("anchorFocus");
            },
            onfocusin(event) {
                var el = event.target;
                this.target = el;
                this.target.classList.add('anchorFocus');
            },
            onfocusout() {
                var el = this.target;
                if (el.classList.contains('visible')) {
                    el.classList.remove('visible');
                }
                el.classList.remove('anchorFocus');
            },
            onClickLi(item, event) {
                event.preventDefault();
                event.stopPropagation();
                this.$emit("changed",item.value);
                this.$emit("input",item.value);
                this.selectedLabel = item.text;
                if (this.target.classList.contains('visible')) {
                    this.target.classList.remove('visible');
                }
            }
        }
    }
</script>

<style scoped>
    :focus {
        outline: none;
    }

    ul {
        margin: 0;
        padding: 0;
    }

    li {
        margin: 0;
    }


    .search-condition-pulldown {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
    }

    .search-condition-pulldown label {
        color: #333333;
        width: 65px;
        text-align: right;
        margin: 0 10px 0 20px;
    }

    .dropdown-check-list {
        display: inline-block;
        height: 42px;
        border: 1px solid #DEE2E6;
        border-radius: 5px;
    }

    .dropdown-check-list .anchor {
        cursor: pointer;
        display: flex;
        padding: 0 50px 0 10px;
        width: 220px;
        height: 42px;
        background: url('../assets/arrow.png') 100% / 8% no-repeat;
        background-position: 95% center;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        align-items: center;
    }

    .dropdown-check-list ul.items {
        padding-inline-start: 0;
        position: absolute;
        display: none;
        margin: 0;
        background: white;
        width: 220px;
        border: 1px solid #0171A3;
        border-radius: 5px;
        z-index: 8;
    }

    .dropdown-check-list ul.items li {
        display: flex;
        list-style: none;
        width: 100%;
        height: 40px;
        padding: 0 10px;
        align-items: center;
    }

    .dropdown-check-list.visible .items {
        display: block;
    }

    .anchorFocus {
        border: 1px solid #0171A3;
    }

    .isoverFlow {
        height: 200px;
        overflow:auto;
    }

</style>